import CustomButton from "../button/button.component";
import "./update-order-status-section.style.css";

const UpdateOrderStatus = ({
  orderData,
  handleStatusChange,
  orderStatus,
  handleButtonClick,
  loadingUpdateOrderStatus,
  sectionTitle,
  sectionDescription,
  containerStyle = {},
  showButton = true,
}) => {
  return (
    // Main container
    <div className="global-section-container" style={containerStyle}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {sectionTitle && (
          <label
            style={{ fontSize: "20px", lineHeight: "24px", fontWeight: 600 }}
          >
            {sectionTitle}
          </label>
        )}
        <label
          style={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "400",
            marginTop: "1%",
          }}
        >
          {sectionDescription}
        </label>

        {/* Dropdown Select */}
        <select
          style={{
            marginTop: "3%",
            padding: "10px",
            fontSize: "16px",
            border: "1px solid #DADADA",
            width: "100%",
            borderRadius: "12px",
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23999'/%3E%3C/svg%3E\")",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 16px center", // 👈 Margin from right
            backgroundSize: "10px",
          }}
          value={orderStatus}
          onChange={handleStatusChange}
          disabled={
            orderData.status === "completed" ||
            orderData.status === "reported" ||
            orderData.status === "resolved" ||
            loadingUpdateOrderStatus
          }
        >
          <option value="" disabled>
            Select status
          </option>
          {orderData?.orderStatusList?.length > 0 &&
            orderData.orderStatusList.map((status, index) => (
              <option key={index} value={status.value}>
                {status.label}
              </option>
            ))}
        </select>
        {showButton && (
          <CustomButton
            title={"Update status"}
            buttonType={"validation"}
            isValid={
              orderData.status === "completed" ||
              orderData.status === "reported" ||
              orderData.status === "resolved" ||
              loadingUpdateOrderStatus
                ? false
                : orderStatus === "completed" || orderData.status === "reported" || orderStatus === "resolved"
                ? true
                : false
            }
            disabled={
              orderData.status === "completed" ||
              orderData.status === "reported" ||
              orderData.status === "resolved" ||
              loadingUpdateOrderStatus
                ? true
                : orderStatus === "completed" || orderData.status === "reported" || orderStatus === "resolved"
                ? false
                : true
            }
            handleButtonClick={handleButtonClick}
            customStyle={{ marginTop: "6%" }}
          />
        )}
      </div>
    </div>
  );
};

export default UpdateOrderStatus;
